import { z } from "zod";
import { Option, tryCatch, UUID } from "@opendaw/lib-std";
import { Promises } from "@opendaw/lib-runtime";
import { Workers } from "./Workers";
const FolderSchema = z.lazy(() => z.object({
    name: z.string(),
    folders: z.array(FolderSchema).optional(),
    uuids: z.array(UUID.zType(z)).optional()
}));
const StructureSchema = z.object({
    version: z.literal(1),
    updatedAt: z.string().optional(),
    folders: z.array(FolderSchema),
    trash: z.array(z.object({ uuid: UUID.zType(z), path: z.string() }))
});
export class StructureFile {
    static FileName = "structure.json";
    static Empty = { version: 1, folders: [], trash: [] };
    #path;
    constructor(folder) { this.#path = `${folder}/${StructureFile.FileName}`; }
    async load() {
        const { status, value } = await Promises.tryCatch(Workers.Opfs.read(this.#path));
        if (status === "rejected") {
            return Option.None;
        }
        const decoded = tryCatch(() => JSON.parse(new TextDecoder().decode(value)));
        if (decoded.status === "failure") {
            console.warn(`'${this.#path}' is not readable json. Ignoring it.`, decoded.error);
            return Option.None;
        }
        const parsed = StructureSchema.safeParse(decoded.value);
        if (!parsed.success) {
            console.warn(`'${this.#path}' is not a valid structure. Ignoring it.`, parsed.error);
            return Option.None;
        }
        return Option.wrap(parsed.data);
    }
    async save(structure) {
        const json = JSON.stringify({ ...structure, updatedAt: new Date().toISOString() });
        return Workers.Opfs.write(this.#path, new TextEncoder().encode(json));
    }
}
